import {
  CLEAR_SUBSCRIPTION_CODE_INFO,
  SET_IS_CHECKING_SUBSCRIPTION_CODE,
  SET_SHARED_BILLING_INFO,
  SET_SUBSCRIPTION_CODE_ERROR_MESSAGE,
} from '../actions/shared-billing';
import createReducer from '../create-reducer';
import { SharedBillingState, initialState } from '../defaults/shared-billing';

function updateSharedBilling(state: any, { payload }: { payload: Partial<SharedBillingState> }) {
  return {
    ...state,
    ...payload,
  };
}

const handlers = {
  [SET_IS_CHECKING_SUBSCRIPTION_CODE]: updateSharedBilling,
  [SET_SHARED_BILLING_INFO]: updateSharedBilling,
  [SET_SUBSCRIPTION_CODE_ERROR_MESSAGE]: updateSharedBilling,
  [CLEAR_SUBSCRIPTION_CODE_INFO]: updateSharedBilling,
};

export default createReducer(initialState, handlers);
